import {
  CheckoutCustomerDetails,
  CheckoutItemDetails,
  CheckoutPaymentDetails,
  CheckoutRequest,
} from '@checkout/util-models';
import { QuoteDetails } from '@domgen/dgx-fe-basket';
import { CustomerDetails, PaymentType } from '@domgen/dgx-fe-common';

export function formatCheckoutRequestsByGroup([
  payment,
  basketId,
  selectedQuotes,
  customerDetails,
]: [
  CheckoutPaymentDetails,
  string | undefined,
  QuoteDetails[],
  CustomerDetails | undefined
]): CheckoutRequest[] | undefined {
  if (!basketId || !customerDetails) {
    return;
  }

  const requestsByGroup: Record<string, CheckoutRequest> =
    selectedQuotes.reduce(
      (requests: Record<string, CheckoutRequest>, quote: QuoteDetails) => {
        const groupCode = quote.clientGroupCode;
        const item = formatCheckoutItemDetails(quote, payment);
        const customer = formatCheckoutCustomerDetails(
          customerDetails,
          groupCode
        );

        if (!requests[groupCode]) {
          requests[groupCode] = {
            basketId,
            customer,
            payment,
            items: [],
          };
        }

        requests[groupCode].items.push(item);
        return requests;
      },
      {}
    );

  return Object.values(requestsByGroup);
}

export function formatCheckoutCustomerDetails(
  {
    telephoneDetails,
    groupMarketingPreferences,
    ...customerDetails
  }: CustomerDetails,
  groupCode: string
): CheckoutCustomerDetails {
  let marketingPreferences = customerDetails.marketingPreferences;

  if (groupMarketingPreferences && groupMarketingPreferences[groupCode]) {
    marketingPreferences = groupMarketingPreferences[groupCode];
  }

  return {
    ...customerDetails,
    telephone: telephoneDetails,
    marketingPreferences,
  };
}

export function formatCheckoutItemDetails(
  quote: QuoteDetails,
  payment: CheckoutPaymentDetails
): CheckoutItemDetails {
  const paymentOption =
    payment.paymentType === PaymentType.Card
      ? quote.cardPaymentOption
      : quote.directDebitPaymentOption;

  return {
    fee: paymentOption?.fee as number,
    itemId: quote.itemId,
    itemType: quote.itemType,
    paymentTerm: quote.paymentTerm,
    periodOfCover: quote.periodOfCover,
    quoteId: quote.quoteId,
    tax: paymentOption?.tax,
  };
}
